import script from "./UserRemoveReferral.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserRemoveReferral.vue?vue&type=script&setup=true&lang=ts"

import "./UserRemoveReferral.vue?vue&type=style&index=0&id=475ae979&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-475ae979"]])

export default __exports__